import PropTypes from 'prop-types'

export default function ChevronRight({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 
           0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 
           4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  )
}

ChevronRight.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

ChevronRight.defaultProps = {
  width: 12,
  height: 12,
  color: 'currentColor',
}
